<spinner *ngIf="generalLoader"></spinner>
<div [ngStyle]="{'display': generalLoader? 'none': 'block' }">
    <router-outlet></router-outlet>
</div>
